(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-color-swatches"] && !Shopify.designMode) return;
  try {
    
  function asTabs() {
    var tabButtons  = document.querySelectorAll('.tab-button');
    var tabContents = document.querySelectorAll('.tab-content');

    tabButtons.forEach(function(button, i) {
      button.addEventListener('click', function() {
        selectTab(i);
      });
    });

    function selectTab(n) {
      // Single-species pages render no tab buttons; nothing to select.
      if (!tabButtons[n]) return;
      tabButtons.forEach(function(button, i) {
        var isActive = i === n;
        button.classList.toggle('active', isActive);
        button.classList.toggle('btn--primary', isActive);
        tabContents[i].classList.toggle('active', isActive);
      });

      var species = tabButtons[n].textContent.trim().toLowerCase().replace(/\s+/g, '-');
      var newUrl  = new URL(window.location.href);
      newUrl.searchParams.set('species', species);
      window.history.replaceState(null, null, newUrl);
    }

    var urlParams    = new URLSearchParams(window.location.search);
    var speciesParam = urlParams.get('species');
    var speciesIndex = Array.from(tabButtons).findIndex(function(button) {
      return button.textContent.trim().toLowerCase().replace(/\s+/g, '-') === speciesParam;
    });
    selectTab(speciesIndex !== -1 ? speciesIndex : 0);
  }

  asTabs();

  } catch(e) { console.error(e); }
})();
})();
